// extracted by mini-css-extract-plugin
export default {"content":"ContentDisplay_content__xfCOW","shape":"ContentDisplay_shape__KWrlO","fadeIn":"ContentDisplay_fadeIn__YHTGb","image":"ContentDisplay_image__Dni-W"};